<template>
  <div class="slider">
    <span class="slider_icon icon icon-zoom-plus" @click="handleIncrease" />
    <vue-slider
      v-if="!hideSlider"
      v-model="sliderValue"
      :tooltip="'none'"
      direction="btt"
      :min="min"
      :max="max"
      :duration="0"
      @change="
        $emit('input', $event);
        $emit('change', $event);
      "
    />
    <article v-else class="slider_gap"></article>
    <span class="slider_icon icon icon-zoom-minus" @click="handleDecrease" />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
export default {
  name: 'ZoomSlider',
  components: {
    VueSlider,
  },
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    hideSlider: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { sliderValue: 10 };
  },
  watch: {
    value(val) {
      this.sliderValue = val;
    },
  },
  methods: {
    handleIncrease() {
      let newValue = this.sliderValue + 10;
      if (this.sliderValue + 10 > this.max) {
        newValue = this.max;
      }
      this.sliderValue = newValue;
      this.$emit('input', this.sliderValue);
      this.$emit('change', this.sliderValue);
    },
    handleDecrease() {
      let newValue = this.sliderValue - 10;
      if (this.sliderValue - 10 < this.min) {
        newValue = this.min;
      }
      this.sliderValue = newValue;
      this.$emit('input', this.sliderValue);
      this.$emit('change', this.sliderValue);
    },
  },
};
</script>

<style lang="scss">
.slider {
  height: 100%;
  display: flex;
  padding: 30px 10px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &_gap {
    height: calc(100% - 5px);
  }
  &_icon {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
  }

  & > .vue-slider {
    display: inline-block;
    margin: 15px 0;
    height: 100% !important;
    .vue-slider-process {
      background-color: transparent !important;
    }
  }
}
</style>
